/**
 * Sentry initialization — must be imported FIRST in index.js before any
 * other application code. Captures JS errors, unhandled promise rejections,
 * React component errors (via ErrorBoundary), and performance transactions.
 */
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
    integrations: [Sentry.browserTracingIntegration()],
    // 20% sampling in production — adjust from Sentry dashboard per-environment
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
    // Only propagate trace headers to our own backend
    tracePropagationTargets: [/\/api\//],
    sendDefaultPii: false,
    // Benign Chromium ResizeObserver quirk — notifications delivered next frame
    ignoreErrors: [
      "ResizeObserver loop completed with undelivered notifications",
      "ResizeObserver loop limit exceeded",
    ],
    beforeSend(event) {
      // Strip any PII that might have leaked into the event
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }
      if (event.request) {
        delete event.request.cookies;
        if (event.request.headers) {
          delete event.request.headers.authorization;
          delete event.request.headers.cookie;
        }
      }
      return event;
    },
  });
}
